import { Helmet } from "react-helmet"
import Header from "../components/global/Header"

function LandingPageLayout({ children, pageTitle }: any): JSX.Element {
  return <div className="grid grid-rows-twoRowLayout h-[100vh]">
    <Helmet>
      <title>{pageTitle ?? 'Home | CSTL'}</title>
    </Helmet>
    <Header />
    {children}
  </div>
}

export default LandingPageLayout